import React, { useState } from "react";
import "./DemoNotice.css";

const DemoNotice = () => {
    const [showNotice, setShowNotice] = useState(true); // ✅ notice always show

    const handleCloseNotice = () => {
        setShowNotice(false); // close notice until user clicks button
    };

    if (!showNotice) return null; // hide notice if closed

    return (
        <div className="demo-notice-overlay">
            <div className="demo-notice-box">
                <h2>⚠ Demo Property Notice</h2>
                <p>
                    This website is currently showing <strong>demo property listings</strong>.
                    <br />
                    Real and verified properties will be published soon.
                </p>
                <button
                    className="demo-notice-btn"
                    onClick={handleCloseNotice}
                    type="button"
                >
                    I Understand, Continue
                </button>
            </div>
        </div>
    );
};

export default DemoNotice;
